import { useContext, createContext } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

const DefaultPortalRefContext = /*#__PURE__*/createContext(undefined);
const DefaultPortalRefProvider = _ref => {
  let {
    children,
    portalRef
  } = _ref;
  return jsx(DefaultPortalRefContext.Provider, {
    value: {
      portalRef
    },
    children: children
  });
};

// we don't want to throw an error if a provider can't be found; just return undefined.
// this allows us to check if a default was provided, and to determine fallbacks locally.
const useDefaultPortalRef = () => {
  var _useContext;
  return (_useContext = useContext(DefaultPortalRefContext)) === null || _useContext === void 0 ? void 0 : _useContext.portalRef;
};

export { DefaultPortalRefProvider, useDefaultPortalRef };
//# sourceMappingURL=DefaultPortalRefProvider.js.map
